import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Input from '../../../Comman/components/Input';
import Modal from 'react-responsive-modal';
import SimpleReactValidator from 'simple-react-validator';
import loader from '../../../Comman/images/loader.gif'
import {InputText} from 'primereact/inputtext';
import {ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {baseUrl} from '../../../Comman/apiEndPoints';
import swal from 'sweetalert';
import { withNamespaces } from 'react-i18next';

import { confirmAlert } from 'react-confirm-alert'; // Import
var approveList = [];
var rejectList = [];
var svValidator;
var engValidator;
const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}
class PendingEditProfileListComponent extends Component {
    constructor(props) {
        super(props);

        this.toggleAll = this.toggleAll.bind(this);
        this.onApproveClick = this.onApproveClick.bind(this);
        this.approveSelected = this.approveSelected.bind(this);
        this.rejectSelected = this.rejectSelected.bind(this);
        this.onRejectClick = this.onRejectClick.bind(this);
        this.handleInput = this.handleInput.bind(this);

        this.state = {
            allApproveSelected: false,
            allRejectSelected: false,
            approveSelection: [],
            rejectSelection: [],
            open: false,
            FirstName:'',
            LastName:'',
            UserId:'',
            RegionId:'',
            viewdetails:false,
            isProfile:false
        };
    }

    componentWillMount() {
        SimpleReactValidator.addLocale('en', {
            required : 'The :attribute field is required.'
        });
        SimpleReactValidator.addLocale('sv', {
            required : 'Fältet :attribute krävs.'
        });
        engValidator = new SimpleReactValidator({
            locale : 'en', 
            autoForceUpdate: this
        });
        svValidator = new SimpleReactValidator({
            locale : 'sv', 
            autoForceUpdate: this
        });
        this.validator = engValidator;
    }

    componentWillReceiveProps(nextProps) { 
        if (nextProps.heartRunnerList.errorMessage !== this.props.heartRunnerList.errorMessage) {
            if(nextProps.heartRunnerList.statusCode==200){                
                swal(nextProps.heartRunnerList.errorMessage) 
            }
        }
        this.translateLang();
    }

    translateLang(){
        var language;
        if(sessionStorage.getItem('Language')){
          language = sessionStorage.getItem('Language');
        }
        else{
          language = "en";
        }
        if(language == "en"){
          this.validator = engValidator;
        }
        else{
          this.validator = svValidator;
        }
    }
    onApproveClick(e) {
        const item = e;
        this.toggleSelection(item);
    }
    onRejectClick(e) {
        const item = e;
        this.toggleRejectSelection(item);
    }

    toggleSelection(item) {
        let approveSelection;

        if (this.isSelected(item)) {
            approveSelection = this.state.approveSelection.filter(x => x !== item);
        } else {
            approveSelection = [...this.state.approveSelection, item];
        }

        const allApproveSelected = approveSelection.length === approveList.length;
        this.setState({ allApproveSelected, approveSelection });
    }

    toggleRejectSelection(item) {
        let rejectSelection;

        if (this.isRejectSelected(item)) {
            rejectSelection = this.state.rejectSelection.filter(x => x !== item);
        } else {
            rejectSelection = [...this.state.rejectSelection, item];
        }
        const allRejectSelected = rejectSelection.length === rejectList.length;
        this.setState({ allRejectSelected, rejectSelection });
    }


    toggleAll(allApproveSelected) {
        const approveSelection = allApproveSelected ? approveList : [];
        this.setState({ allApproveSelected, approveSelection });
    }

    isSelected=(item)=> {
        return (this.state.approveSelection.includes(item));
    }

    isRejectSelected=(item)=> {
        return (this.state.rejectSelection.includes(item));
    }

    approveSelected() {
        
        let approvalItems=this.state.approveSelection.map((item,index)=>{
          item.IsApproved=1;
          return item;
        })
        
            this.props.onApprove(this.state.approveSelection);
            this.setState({
                allApproveSelected: false,
                approveSelection: []
            });
        
    } 

    rejectSelected(rowData) { 
        const { t } = this.props;
        confirmAlert({
            title: `${t('First_Responder.Confirm to reject')}`,
            message: `${t('First_Responder.Are you sure to reject this?')}`,
            buttons: [
              {
                label: `${t('First_Responder.Yes')}`,
                onClick: () => {
                    let UserId=rowData.UserId;
                    this.props.onReject({UserId:UserId,IsApproved:2,OrganizationID:this.props.match.params.id},this.state.RegionId == '' ? (this.props.heartRunnerList.regionList.length > 0 ? this.props.heartRunnerList.regionList[0].ID : null) : this.state.RegionId);
              }
              },
              {
                label: `${t('First_Responder.No')}`,
                onClick: () => {
                }
              }
            ]
          }); 
    }

    approveNewDevice=(rowData)=>{
        let approveheartRunnerList=[];
        approveheartRunnerList.push(rowData);
        let approvalItems=approveheartRunnerList.map((item,index)=>{
            item.IsApproved=1;
            return item;
          }) 
        this.props.onApprove(approvalItems[0],this.state.RegionId == '' ? (this.props.heartRunnerList.regionList.length > 0 ? this.props.heartRunnerList.regionList[0].ID : null) : this.state.RegionId);
        this.setState({
            allApproveSelected: false,
            approveSelection: []
        });
        
    }

    approveCheckbox = (rowData)=>{
        const { t } = this.props;
        return(
               <div> 
                <span className="enable-cursor delbtn" onClick={() => { this.openViewModal(rowData) }} title={t('First_Responder.View')}>    <i className="fa fa-eye"></i></span>     
                <span className="enable-cursor delbtn" onClick={() => { this.rejectSelected(rowData) }} title={t('First_Responder.Reject')}>    <i className="fa fa-thumbs-down"></i></span>     
                
                 <span className="enable-cursor delbtn" onClick={() => { this.approveNewDevice(rowData) }} title={t("First_Responder.Approve")}><i className="fa fa-thumbs-up" aria-hidden="true"></i></span>
               
                </div>
            )
    } 
 
    closeViewModal = () => {
        this.setState({ viewdetails: false })
    }
 
    openViewModal=(rowData)=> {
        this.setState({ viewdetails: true }) 
        sleep(500).then(() => {
            
            document.getElementById("fName").value = rowData.FirstName ? rowData.FirstName : '';
            document.getElementById("lName").value = rowData.LastName ? rowData.LastName : '';
            document.getElementById("aliName").value = rowData.Alias ? rowData.Alias : '';
            document.getElementById("Email").value = rowData.EmailId ? rowData.EmailId : '';
            document.getElementById("PhoneNumber").value = rowData.PhoneNumber ? rowData.PhoneNumber : '';
            // document.getElementById("CertificateId").value = rowData.CertificateId ? rowData.CertificateId : '';
            document.getElementById("WorkingPlace").value = rowData.WorkingPlace ? rowData.WorkingPlace : '';
            document.getElementById("Proffession").value = rowData.Proffession ? rowData.Proffession : '';
            document.getElementById("CPREducation").value = rowData.CPREducation ? rowData.CPREducation : '';
        })   
        this.setState({isProfile : (rowData.Image ? true : false)})
        sleep(500).then(() => {
            if(rowData.Image){
                document.getElementById("profile-img-src").src = baseUrl + rowData.Image;
            }
            else{
                var nameInitials = rowData.FirstName.charAt(0).toUpperCase() + rowData.LastName.charAt(0).toUpperCase();
                document.getElementById("name-initials").innerHTML =  nameInitials;
            }
        })

    }
    handleInput(e) {
       
       let value = e.target.value;
       let name = e.target.name;
        /*this.setState( prevState => ({ prevState : 
            {...prevState.statusSettings, [name]: value}
        }),  )*/
       this.setState(
        {rejectReason: value}
        )
    }
    notify = (message) => {
        /* toast("Default Notification !");*/
          
         this.toastId =toast.success(message, {
           position: toast.POSITION.TOP_CENTER
         });
         this.closeModal();
        //  this.props.getPendingList();
    }
changeRegion = (e) => {
        let value = e.target.value;
        let payload = {
            RegionId: value,
        }
        this.state.RegionId = value.toString();
        this.setState({ RegionId: value.toString() });

        this.props.getUserList(payload)

        // sleep(3000).then(() => {
        //     console.log("setstate",this.state);
        // })
    }
    render() {
        //approveList = this.props.heartRunnerList.deviceApproveList;
        const { t } = this.props;
        let  regionListOption;
      let regionList=this.props.heartRunnerList.regionList;
      if(regionList){
          regionListOption = regionList.map((item) =>
                <option style={{background : '#f5f1f1'}} value={item.ID} key={item.ID}>{item.RegionName}</option>
            );
        }
        var header = <div className="search-name">
                        <i className="fa fa-search" style={{margin:'4px 4px 0 0'}}></i>
                        <InputText type="text" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder={t('First_Responder.Search')} size="50"/>
                    </div>;
        return (
             <div >
                <div className="progressbar-heading grids-heading">
                    <h2>{t('First_Responder.Pending First Responder Edit Profiles Requests')}</h2>
                </div>
                {/* <ToastContainer /> */}
                <div className=" forms-panel w3-last-form">
                        <div className="forms add-device">
                            <div className="form-three widget-shadow">
                                <div className=" panel-body-inputin">
                                      <div className="text-left m-b-25 ">


                                    <select id="regionData" style={{ fontSize: 'large', padding: '7px' }}
                                        onChange={this.changeRegion}
                                        placeholder="Select"
                                        ref="regionData"
                                        name={'RegionId'}
                                    >
                                        {regionListOption}
                                    </select>
                                </div>
                                   
                                    <div className="w3l_search">
                                        {header}
                                    </div>
                                    <div className="devicestable">
                                    
                                   
                                      <br />                  
                                    

                                      <DataTable 
                                      className="table" 
                                      value={this.props.heartRunnerList.pendingEditProfileList} 
                                      loading={this.props.heartRunnerList.isLoading}  
                                      paginator={true} rows={10}
                                      globalFilter={this.state.globalFilter}
                                      emptyMessage={t('First_Responder.No records found')}
                                  >
                                      <Column field="UserId" header="" className="noDisplay" />
                                      
                                      <Column sortable={true} field="FirstName" header={t('First_Responder.First Name')} />
                                      <Column sortable={true} field="LastName" header={t('First_Responder.Last Name')} />
                                      <Column sortable={true} field="Alias" header={t('First_Responder.Alias Name')} />
                                      <Column sortable={true} field="EmailId" className="wordBreakLine" header={t('First_Responder.Email')} />
                                      {/* <Column sortable={true} field="Username" header="Username" /> */}
                                      <Column sortable={true} field="PhoneNumber" header={t('First_Responder.Phone Number')} />
                                      {/* <Column sortable={true} field="CertificateId" header={t('First_Responder.Certification ID')} /> */}
                                     
                                     
                                      <Column header={
                                          <div>
                                              <span style={{margin:'0px 50px 0 0'}} ><i></i></span>
                                          </div>
                                      } 
                                      body={this.approveCheckbox}
                                     
                                      />
                                     
                                  </DataTable>
                                </div>
                                </div>
                            </div>
                        </div>    
                </div>  
                <Modal open={this.state.viewdetails}  onClose={this.closeViewModal} center> 
                      <div className="modal1 alarmsetmodal">
                          <div className="progressbar-heading grids-heading">
                                   <h2>{t('First_Responder.View First Responder Information')}</h2>
                          </div>
                            <div className="profile-dp">
                                { this.state.isProfile ? 
                                    <img className="profile-img" id="profile-img-src" src="" alt="" /> 
                                :
                                    <div id="name-initials"></div>
                                }
                            </div>
                            <form className="form-horizontal">
                                <Input 
                                   type={'text'}
                                   title={t('First_Responder.First Name')}
                                   name= {'FirstName'}
                                   placeholder = {t('First_Responder.Enter First Name')}
                                   icon="fa fa-user"
                                   id="fName"
                                   readOnly
                                                                  
                                /> {/* Name of the user */}
                                <Input 
                                   type={'text'}
                                   title= {t('First_Responder.Last Name')} 
                                   name= {'LastName'}
                                   placeholder = {t('First_Responder.Enter Last Name')}
                                   icon="fa fa-user"
                                   id="lName"
                                   readOnly
                                /> {/* Name of the user */}
                                  <Input 
                                   type={'text'}
                                   title={t('First_Responder.Alias Name')}
                                   name= {'AliasName'}
                                //    placeholder = {t('First_Responder.Enter Alias Name')}
                                   icon="fa fa-user"
                                   id="aliName"
                                   readOnly
                                                                  
                                />
                                <Input 
                                   type={'text'}
                                   icon="fa fa-envelope"
                                   title= {t('First_Responder.Email ID')}
                                   id="Email"
                                   readOnly
                                /> {/* Name of the user */}
                                <Input 
                                   type={'text'}
                                   title= {t('First_Responder.Phone Number')} 
                                   icon="fa fa-phone"
                                   id="PhoneNumber"
                                   readOnly
                                /> {/* Name of the user */}
                                {/* <Input 
                                   type={'text'}
                                   title= {t('First_Responder.Certification ID')}
                                   icon="fa fa-certificate"
                                   id="CertificateId"
                                   readOnly
                                /> */}
                                <Input 
                                   type={'text'}
                                   title= {t('First_Responder.CPREducation')} 
                                   icon=""
                                   id="CPREducation"
                                   readOnly
                                />
                                <Input 
                                   type={'text'}
                                   title= {t('First_Responder.Proffession')} 
                                   icon=""
                                   id="Proffession"
                                   readOnly
                                />
                                <Input 
                                   type={'text'}
                                   title= {t('First_Responder.WorkingPlace')}
                                   icon=""
                                   id="WorkingPlace"
                                   readOnly
                                />
                                
                           </form> 
                        </div>
                </Modal>
                
            </div>
        )
    }
}

export default withNamespaces()(withRouter(PendingEditProfileListComponent));

